/**
 * @generated SignedSource<<259225c79f8e6fd83a31e3356d1952b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteProductInput = {
  _id: string;
};
export type Table_delete_Mutation$variables = {
  data: DeleteProductInput;
};
export type Table_delete_Mutation$data = {
  readonly deleteProduct: {
    readonly _id: string;
  };
};
export type Table_delete_Mutation = {
  response: Table_delete_Mutation$data;
  variables: Table_delete_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "data"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "ProductIdModel",
    "kind": "LinkedField",
    "name": "deleteProduct",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "_id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Table_delete_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Table_delete_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d99cb027c6de231135c841a7e2a2a7bd",
    "id": null,
    "metadata": {},
    "name": "Table_delete_Mutation",
    "operationKind": "mutation",
    "text": "mutation Table_delete_Mutation(\n  $data: DeleteProductInput!\n) {\n  deleteProduct(data: $data) {\n    _id\n  }\n}\n"
  }
};
})();

(node as any).hash = "eab91a21a00d7a14b0eca42bc33c877e";

export default node;
